/** Splits text into parts, marking the ones that match a word of the search (case-insensitive). */
export function highlightParts(text: string, term: string | undefined): { text: string; hit: boolean }[] {
  const words = [...new Set((term ?? '').split(/\s+/).map((w) => w.replace(/^"|"$/g, '')).filter((w) => w.length > 0))];
  if (!words.length || !text) return [{ text, hit: false }];
  const re = new RegExp(`(${words.sort((a, b) => b.length - a.length).map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi');
  return text.split(re).map((p, i) => ({ text: p, hit: i % 2 === 1 })).filter((p) => p.text !== '');
}
